import styled from 'styled-components';

// ═══════════════════════════════════════════════════════════════════
// Extraído de `NewRoute/styles.ts` (Task 3 del refactor de patrones RV,
// 2026-07-07) — mismas reglas, ahora exclusivas de este componente.
// `ContentArea`/`MainContent` se consolidaron en `../MainStyledComponents`
// (review Task 2: eran byte-idénticos al par de `OperarisTabContent`).
// ═══════════════════════════════════════════════════════════════════

export const FormSection = styled.div`
  background: ${({ theme }) => theme.colors.backgroundLila};
  border-radius: 0.8rem;
  padding: ${({ theme }) => theme.spacing.xl};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.l};
`;

export const FormRow = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.l};
  flex-wrap: wrap;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    flex-direction: column;
  }
`;

/* `FormField` y `PKRow` viven ahora en `RoadRangesFields/styles` — los comparte
   el bloque de carreteras extraído a componente (plantillas de recorrido,
   2026-08-16). Se reexportan para que haya UNA sola definición y para no tocar
   los imports de este tab ni de sus hermanos. */
export { FormField, PKRow } from '../../../../../components/forms/RoadRangesFields/styles';

/* Fix 2026-07-04 (mockup del spec): en la tab Ubicación el form va a la
   izquierda y el MAPA a la derecha, mitad y mitad aprox. En tablet vertical
   el mapa baja debajo del form. */
export const MapColumn = styled.div`
  flex: 1;
  min-width: 0;
  min-height: 34rem;
  border-radius: 0.8rem;
  overflow: hidden;

  /* Fix 2026-07-04 (feedback usuario): el mapa CRECE hasta igualar la altura
     de la card del form (la columna ya estira por el flex row) — pisa el
     height fijo de 40rem del MapContainer de MapWithSegments. */
  & > div {
    height: 100%;
  }

  /* Tour P4 (2026-07-06): al apilar en columna el eje principal pasa a ser
     VERTICAL y el flex:1 (basis 0) de esta columna pisaba su height → caía
     al min-height y el hijo con height:100% quedaba a 0px ("el mapa
     desaparece"). Igual que el canónico LocationForm.MainContainer +
     MapContainer: se resetea el flex y manda una altura EXPLÍCITA. El
     reset vive AQUÍ (no en ContentArea > *) porque esta regla se define
     después y ganaría por orden de inyección. */
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    flex: 0 0 auto;
    height: 45rem;
    min-height: 0;
  }

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    height: 50rem;
  }
`;

/**
 * Aviso de «este recorrido ya tiene tramos».
 *
 * 🔴 Antes era un `Typography` gris del mismo tamaño que las etiquetas del
 * formulario, colocado entre el selector de carreteras y los PK. Renderizaba
 * —comprobado midiéndolo: dentro de la ventana, a 532 px— y aun así **nadie lo
 * veía**: en un panel lleno de etiquetas grises, un texto gris más no es un
 * aviso, es una etiqueta más (feedback usuario 2026-08-24, dos veces).
 *
 * Se le da la forma que la aplicación ya usa para avisar (el `Badge` externo):
 * naranja secundario sobre su fondo al 10 %, con borde. Los tokens son los
 * mismos, no se inventa ninguno.
 */
export const RoadChangeNotice = styled.div`
  display: flex;
  gap: 0.8rem;
  align-items: flex-start;

  margin: 0.4rem 0 1.2rem;
  padding: 0.8rem 1.2rem;

  border: 1px solid ${({ theme }) => theme.colors.secondaryOrange};
  border-radius: 0.6rem;
  background-color: ${({ theme }) => theme.colors.orangeTransparent};

  color: ${({ theme }) => theme.colors.secondaryOrange};
  font-size: 1.4rem;
  line-height: 1.4;
`;

/** El símbolo, para que no se lea como parte de la frase. */
export const RoadChangeNoticeIcon = styled.span`
  flex: none;
  font-size: 1.6rem;
  line-height: 1.2;
`;
